/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';
import { TimeFrame } from '../models/TimeFrame';

export class ListBillingTransactionHistoryRequest {
  'cloudProvider'?: Provider;
  'timeFrame': TimeFrame;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "timeFrame",
      "baseName": "timeFrame",
      "type": "TimeFrame",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListBillingTransactionHistoryRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



